import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';

export const sendCampaignReminders = () => {
    return handleResponse(api().get('notify/campaigns/reminders'));
};
